// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__3OmGX","slider":"styles_slider__28U8V","checkbox":"styles_checkbox__3WI2Z","round":"styles_round__2u1wA"};